import type {
  GenerativeAiAgentIdLogRunsResponse,
  GenerativeAiAgentIdLogRunsResult,
  GenerativeAiAgentIdLogRunRow,
} from "./types";

/**
 * Shapes the API's runs into Evaluation Logs table rows, each run's rule evaluations nested as
 * its sub-rows. Row ids are prefixed by kind: a log written before run ids existed is a run of
 * its own whose run id is its invocation id, which would otherwise collide with its only child.
 */
export const toGenerativeAiAgentIdLogRunsResult = (
  response: GenerativeAiAgentIdLogRunsResponse
): GenerativeAiAgentIdLogRunsResult => ({
  hits: response.hits,
  hits_capped: response.hits_capped,
  present_outcomes: response.present_outcomes,
  results: response.results.map(
    ({ invocations, ...run }): GenerativeAiAgentIdLogRunRow => ({
      ...run,
      id: `run:${run.run_id}`,
      kind: "run",
      invocations: invocations.map((invocation, index) => ({
        ...invocation,
        id: `invocation:${invocation.invocation_id}`,
        kind: "invocation",
        position: index + 1,
        invocation_count: invocations.length,
      })),
    })
  ),
});
